import { render } from "./SupportAgents.vue?vue&type=template&id=275f1690"
import script from "./SupportAgents.vue?vue&type=script&lang=js"
export * from "./SupportAgents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__